export interface SettingsData {
    QAS: any;
}

export default class Settings {
    static LOCAL_STORAGE_ITEM_NAME: string = 'qas-tool';

    public QAS: any = {
      endpoint: ''
    };

    constructor (options?: any) {
      this.init(options)
    }

    get qasEndpoint (): string {
      let result: string = ''
      if (this.QAS && this.QAS.endpoint) {
        result = this.QAS.endpoint
      }
      return result
    }

    init (options?: any): void {
      console.log('Settings: init', options)
      if (options) {
        this.initWithData(options)
      } else if (this.loadFromLocalStorage()) {
        console.log('loaded settings from local storage.')
      } else {
        console.log('could not load settings from local storage.')
        this.initWithData()
      }
    }

    initWithData (options: any | any = {}): void {
      console.log('Settings: initWithData', options)
      // super.initWithData(options);
      if (options.QAS) {
        this.QAS = options.QAS
      }
    }

    saveToLocalStorage (): boolean {
      console.log('Settings: saveToLocalStorage')
      const localStorage = window.localStorage
      try {
        const dataText = JSON.stringify(this.json)
        const localStorageItemName: string = Settings.LOCAL_STORAGE_ITEM_NAME
        console.log(localStorageItemName, dataText)
        localStorage.setItem(localStorageItemName, dataText)
        return true
      } catch (error) {
        console.log('saveToLocalStorage:', error)
        return false
      }
    }

    loadFromLocalStorage (): boolean {
      let result = false
      const localStorage = window ? window.localStorage : undefined

      if (localStorage) {
        const settingsText: string | null = localStorage.getItem(Settings.LOCAL_STORAGE_ITEM_NAME)
        console.log('loadFromLocalStorage: ', settingsText)
        if (settingsText) {
          try {
            const settings = JSON.parse(settingsText)
            this.initWithData(settings)
            result = true
          } catch (error) {
            console.log('loadFromLocalStorage', error)
          }
        }
      }
      return result
    }

    get json (): any {
      const json: any = {
        QAS: this.QAS
      }
      return json
    }
}
